export const NIAGARA_ICEDOGS_ORGANIZATION_UUID = '001ba6b5-0595-4133-8ec9-1fa29df4154c';
/** Remitted to the City of St. Catharines per club-seat season ticket. */
export const CLUB_SEAT_LICENSE_FEE_PER_SEAT = 339;
export const isClubSeatLicenseFeeReportEnabled = (organizationUUID) => String(organizationUUID ?? '')
    .trim()
    .toLowerCase() === NIAGARA_ICEDOGS_ORGANIZATION_UUID;
